export const API_URL = import.meta.env.VITE_API_URL;
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
export const GA_KEY = import.meta.env.VITE_GA_KEY ?? '';
export const IMBEE_KEY = import.meta.env.VITE_IMBEE_KEY;
export const INSIGHTS_INSTRUMENTATION_KEY = import.meta.env.VITE_INSIGHTS_INSTRUMENTATION_KEY ?? '';
export const BARRAVAS_URL = import.meta.env.VITE_BARRAVAS_URL ?? '';
export const RECAPTCHA_KEY = import.meta.env.VITE_RECAPTCHA_KEY ?? '';
export const WHATSAPP_URL = import.meta.env.VITE_WHATSAPP_URL ?? '';

export const TIEMPO_BANNER = import.meta.env.VITE_TIEMPO_BANNER ?? 5;

export const MARCADOR_DESARROLLO = import.meta.env.VITE_MARCADOR_DESARROLLO === 'true';
export const DESPLEGAR_NO_ARRANCA = import.meta.env.VITE_DESPLEGAR_NO_ARRANCA === 'true';
export const MOSTRAR_NO_ARRANCA = import.meta.env.VITE_MOSTRAR_NO_ARRANCA === 'true';
export const MOSTRAR_DESTINO = import.meta.env.VITE_MOSTRAR_DESTINO === 'true';
export const MOSTRAR_RUTA = import.meta.env.VITE_MOSTRAR_RUTA === 'true';
